// angular.module('HeroPRO').filter('selectedOptions',

/* @ngInject */
export default function SelectedOptionsFilter(limitToFilter) {
    return function (items) {
        const ordered = [];
        angular.forEach(items, (item) => {
            ordered.push(item);
        });
        ordered.sort((a, b) => {
            if (a.isChecked === b.isChecked) {
                return a.DisplayName - b.DisplayName;
            } else if (a.isChecked) {
                return -1;
            }
            return -1;
        });

        return limitToFilter(ordered, 10);
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/filters/selectedOptionsFilter.js